import BlogPage from 'pages/Blog';
import BlogDetailPage from 'pages/Blog/ui/BlogDetailPage/BlogDetailPage';
import React from 'react';
import { RouteProps } from 'react-router-dom';

export enum Blog {
  LIST = 'list',
  DETAILS = 'details',
}

export const blogPath: Record<Blog, string> = {
  [Blog.LIST]: '/',
  [Blog.DETAILS]: '/:article',
};

export const blogRouteConfig: Record<Blog, RouteProps> = {
  [Blog.LIST]: {
    path: blogPath.list,
    element: <BlogPage />,
  },
  [Blog.DETAILS]: {
    path: blogPath.details,
    element: <BlogDetailPage />,
  },
};
